import { css } from '@emotion/react'
import { CSSProperties, memo, ReactNode } from 'react'
import { palette } from '../styles/colors'

const rootStyles = css({
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'absolute',
    alignItems: 'center',
    color: palette.contrastText,
    display: 'flex',
    height: '100%',
    width: '100%',
})
const loadingStyles = css({
    fontWeight: 'bolder',
    letterSpacing: 4.7,
    paddingLeft: 4.7,
    fontSize: 12,
})

interface ILoading {
    text?: string
    style?: CSSProperties
    className?: string
    children?: ReactNode
}

const Loading = memo((props: ILoading) => {
    const { text = 'LOADING...', style, children, className } = props
    return (
        <div style={style} className={className} css={rootStyles}>
            <span css={loadingStyles}>{text}</span>
            {children}
        </div>
    )
})

export default Loading
